import { TranslateFunction } from "@ds/base";
import { AppTranslationProvider } from "@ds/react-utils";
import React, { FunctionComponent } from "react";
import { fetchTranslationFunction } from "./TranslationProvider";

const Translate: FunctionComponent<{}> = ({ children }) => {

    const fetchTranslate = (lang: string): Promise<TranslateFunction> => {
        return fetchTranslationFunction(lang);
    };

    return <AppTranslationProvider fetchTranslate={fetchTranslate}>
        {children}
    </AppTranslationProvider>;
}

export default Translate;
